<ion-content>
  <ng-container *transloco="let t">
    <div id="close-button-container">
      <ion-button (click)="close()" fill="clear" color="light">
        <ion-icon name="close" slot="start"></ion-icon>
        {{ t('Close') }}
      </ion-button>
    </div>

    <div class="swiper-wrapper">
    <swiper [config]="sliderOpts" [virtual]="true" (swiper)="swiperInit($event)">
      <ng-template swiperSlide>
      <div class="swiper-zoom-container">
          <img [src]="img" class="swiper-lazy" />
          <!-- Required swiper-lazy class and image source specified in data-src attribute -->
          <!-- Preloader image -->s
          <div
          class="swiper-lazy-preloader swiper-lazy-preloader-white"
        ></div>
      </div>
      </ng-template>
    </swiper>
    </div>


    <!---We need to add this manually in the swiper  due to a bug in ionic
      Workaround adapted from: https://github.com/SimonGolms/ngx-ionic-image-viewer/blob/master/projects/ngx-ionic-image-viewer/src/lib/viewer-modal/viewer-modal.component.ts
    <ion-slide>
      <div class="swiper-zoom-container">
        <img [src]="img">
      </div>
    </ion-slide>
    -->

    <div id="zoom-buttons-container">
      <ion-button (click)="zoom(false)" fill="clear" color="light">
        <ion-icon name="remove-circle-outline" slot="start"></ion-icon>
        {{ t('Zoom out') }}
      </ion-button>
      <ion-button (click)="zoom(true)" fill="clear" color="light">
        <ion-icon name="add-circle-outline" slot="start"></ion-icon>
        {{ t('Zoom in') }}
      </ion-button>
    </div>
  </ng-container>
</ion-content>
